"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrackingUtility = exports.EVENT_LABEL = exports.EVENT_ACTION = undefined;

var _ramda = require("ramda");

var _functional_utility = require("./functional_utility");

var EVENT_CATEGORY = {
    "fx": "fund explorer",
    "pdp": "pdp",
    "downloads": "downloads",
    "fundDoc": "fund documents",
    "docsubscription": "fund document subscription",
    "brightcove_video": "brightcove video",
    "jtf": "product search"
};

var EVENT_ACTION = exports.EVENT_ACTION = {
    "region": "region",
    "assetClass": "asset class",
    "investmentStyle": "investment style",
    "currency": "currency",
    "riskLevel": "risk level type",
    "distributionFrequency": "dividend type",
    "fundType": "fund type",
    "shareClass": "share class",
    "premiumDiscount": "discount premium",
    "dividendPolicy": "dividend policy",
    "resetFilters": "reset filters",
    "sort": "sort",
    "FUND_SELECTION": "fund selection",
    "net-inflow-outflow-chart-container": "net inflows/outflows chart",
    "daily-weekly-liquidity-chart-container": "daily & weekly liquid assets chart",
    "fund-nav-chart-container": "fund level market-based nav chart",
    "shareclass-intraday-nav-chart-container": "share class market-based nav chart",
    "downloadHoldings": "download all holdings",
    "addToFavorites": "add to favorites",
    "removeFromFavorites": "remove from favorites",
    "subscribeToProductLiteratureCta": "Subscribe to product literature"
};

var EVENT_LABEL = exports.EVENT_LABEL = {
    "chartHover": "chart hover",
    "clickUrl": "Click URL"
};

var hasValidTrackingProps = function hasValidTrackingProps(obj, hasProps) {
    var ignoreValidation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (ignoreValidation) {
        return true;
    }
    var validEventCategoryProp = function validEventCategoryProp(trackingObj) {
        return (0, _ramda.has)("eventCategory")(trackingObj) && !(0, _functional_utility.isNilOrEmpty)(trackingObj.eventCategory);
    };
    var validEventActionProp = function validEventActionProp(trackingObj) {
        return (0, _ramda.has)("eventAction")(trackingObj) && !(0, _functional_utility.isNilOrEmpty)(trackingObj.eventAction);
    };
    var validEventLabelProp = hasProps ? function (trackingObj) {
        return (0, _ramda.has)("eventLabel")(trackingObj) && !(0, _functional_utility.isNilOrEmpty)(trackingObj.eventLabel);
    } : function () {
        return true;
    };

    return (0, _ramda.allPass)([validEventCategoryProp, validEventActionProp, validEventLabelProp])(obj);
};

var TrackingUtility = exports.TrackingUtility = {
    trackEvent: function trackEvent(obj) {
        var hasProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var ignoreValidation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if ((0, _ramda.isNil)(obj) || !hasValidTrackingProps(obj, hasProps, ignoreValidation)) {
            return false;
        }

        if ((0, _ramda.isNil)(window.dataLayer)) {
            window.dataLayer = [];
        }

        var defaultObj = {
            "event": "gaEvent"
        };
        var trackingObj = (0, _ramda.mergeDeepRight)(defaultObj, obj);

        window.dataLayer.push(trackingObj);
    },
    getEventCategory: function getEventCategory(key) {
        return (0, _ramda.isNil)(EVENT_CATEGORY[key]) || (0, _functional_utility.isNilOrEmpty)(key) ? "" : EVENT_CATEGORY[key];
    },
    getEventAction: function getEventAction(key) {
        return (0, _ramda.isNil)(EVENT_ACTION[key]) || (0, _functional_utility.isNilOrEmpty)(key) ? "" : EVENT_ACTION[key];
    },
    getEventLabel: function getEventLabel(key) {
        return (0, _ramda.isNil)(EVENT_LABEL[key]) || (0, _functional_utility.isNilOrEmpty)(key) ? "" : EVENT_LABEL[key];
    },
    getDownloadsTracking: function getDownloadsTracking(url, path) {
        return {
            "eventCategory": this.getEventCategory("downloads"),
            "eventAction": 'document: '.concat(url),
            "eventLabel": 'from: '.concat(path)
        };
    },
    getSubscribeToProductCTATracking: function getSubscribeToProductCTATracking(category, action, label) {
        return {
            "eventCategory": this.getEventCategory(category),
            "eventAction": this.getEventAction(action),
            "eventLabel": label
        };
    },
    getFundFavoriteTracking: function getFundFavoriteTracking(category, action, label) {
        return {
            "eventCategory": this.getEventCategory(category),
            "eventAction": this.getEventAction(action),
            "eventLabel": label
        };
    }
};